<template>
  <v-sheet class="pa-4" color="#6599f9">
    <v-text-field
      v-model="search"
      @input="$emit('list:searching', search)"
      :label="label"
      dark
      flat
      solo-inverted
      hide-details
      clearable
      clear-icon="mdi-close-circle-outline"
    ></v-text-field>
  </v-sheet>
</template>

<script>
export default {
  name: 'ListSearch',
  props: ['label'],
  data: () => ({
    search: '',
  }),
};
</script>
